import Vue from 'vue'
import VueMeta from 'vue-meta'
import App from './App.vue'
import router from './router'
import store from './store'
import {formatMoney} from '@/utils/filters';
import { BTable, ModalPlugin, IconsPlugin, SpinnerPlugin, ToastPlugin } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

Vue.config.productionTip = false


Vue.component('b-table', BTable)

Vue.filter('money', formatMoney);

Vue.use(VueMeta)
Vue.use(SpinnerPlugin)
Vue.use(IconsPlugin)
Vue.use(ModalPlugin)
Vue.use(ToastPlugin)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
